const getDefaultOrderState = () => ({
  order: '',
});

export default {
  state: getDefaultOrderState(),
  actions: {
    async GET_CLIENT_ORDER_DETAILS(context, payload) {
      const request = await fetch(
        'https://bookings.class4kids.co.uk/api/v4/people/parent/orders',
        {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({
            orderId: payload.orderId,
          }),
        },
      );
      const json = await request.json();
      await context.commit('UPDATE_CLIENT_ORDER_DETAILS', json.data);
    },
  },

  mutations: {
    UPDATE_CLIENT_ORDER_DETAILS(state, payload) {
      state.order = payload;
    },
    RESET_ORDER_STATE(state) {
      Object.assign(state, getDefaultOrderState());
    },
  },

  getters: {
    order(state) {
      return state.order;
    },
  },
};
